import service from '@/utils/server';

const modName='/md/customer/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

/**
 * 初始化
 * @param data
 * @returns {*}
 */
export const customerEditInit = data => {
  return service({
    url: modName + 'customerEditInit',
    method: 'post',
    data
  });
};

/**
 * 保存
 * @param data
 * @returns {*}
 */
export const customerSave = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

/**
 * 删除
 * @param data
 * @returns {*}
 */
export const customerDelete = data => {
  return service({
    url: modName + 'delete',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/distributor/api/index.js